import React from 'react';
import { Helmet } from 'react-helmet';
import { FaArrowDown } from 'react-icons/fa'; // Importing down arrow icon from react-icons/fa

const ProjectRow = ({ title, description, date, link }) => {
  const truncatedDescription =
    description.length > 50 ? `${description.slice(0, 50)}...` : description;

  return (
    <div className="block custom-font">
      <div className="flex justify-between items-center p-4 transition duration-300 ease-in-out">
        <div className="w-1/2">
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="text-lg font-semibold text-orange-600 hover:underline"
          >
            {title}
          </a>
          <p className="text-sm mt-2">{truncatedDescription}</p>
        </div>
        <div className="w-1/4 text-right flex items-center"> {/* Modified */}
          <p className="text-md mr-1">{date}</p> {/* Moved the date inside the flex container */}
        </div>
      </div>
    </div>
  );
};

const EmptyRepo = () => {
  return (
    <div className="custom-font mt-9 mx-auto max-w-screen-xl">
      <Helmet>
        <title>Personal Projects</title>
        <meta name="author" content="Dinis Martinho" />
      </Helmet>

      <div className="text-black">
        <div className="flex justify-between items-center border-b-2 border-orange-600 px-4 border-l-2">
          <div className="w-1/2">
            <h2 className="text-lg font-semibold text-orange-600">Personal Projects</h2>
          </div>
          <div className="w-1/4 text-right flex items-center"> {/* Modified */}
            <h2 className="text-lg font-semibold text-orange-600 mr-1">Date</h2> {/* Moved the date inside the flex container */}
            <FaArrowDown className="text-orange-600" /> {/* Down arrow icon */}
          </div>
        </div>

        <div className='border-r-2 border-orange-600'>
        <ProjectRow
          title="Procedurally-Animated-Shark"
          description="Example demo of a procedurally animated shark showcasing Unity's potential for organic animations."
          date="Jan 9, 2023"
          link={process.env.PUBLIC_URL + '/Procedurally-Animated-Shark'}
        />
        </div>

        
        
        {/* Add more ProjectRow components for other projects */}
      </div>
    </div>
  );
};

export default EmptyRepo;
